import {
  postCreateOrEditClinicianGroup,
  disableClinicianGroup,
} from '../../../actions/areas/clinicianGroups/commandActions';
import globals from '../../../globals/communityGlobals';

const clinicianGroupWithDefaultValues = {
  name: undefined,
  orgUnitOption: null,
  clinicianOptions: [],
  dateFrom: globals.now,
  dateTo: globals.now,
};
const locale = globals.getAreas(['clinicianGroups', 'error', 'selectableListsValues', 'userActions']);

export const eventHandlers = (state, setState, auth) => {
  const handleSidePanel = (isOpen, data) => {
    // eslint-disable-next-line no-unused-expressions
    data != null
      ? setState(newState => ({
          ...newState,
          openClinicianGroupPanel: isOpen,
          clinicianGroupWithDefaultValues: data,
        }))
      : setState(newState => ({ ...newState, openClinicianGroupPanel: isOpen, clinicianGroupWithDefaultValues }));
  };
  const refreshTable = () =>
    setState(newState => ({
      ...newState,
      forceReload: !state.forceReload,
      openClinicianGroupPanel: false,
      openWarningSidePanel: false,
      errorMsg: null,
    }));
  const updateTableProps = (currentPage, pageSize) => setState({ ...state, currentPage, pageSize });
  const updateTableSort = (sortColumn, sortDirection) => setState({ ...state, sortColumn, sortDirection });
  const errorCallback = response => {
    setState(newState => ({ ...newState, errorMsg: response }));
  };

  const onClose = () => {
    setState(newState => ({ ...newState, openClinicianGroupPanel: false, errorMsg: null }));
  };

  const handleWarningPanel = (isOpen, data) => {
    // eslint-disable-next-line no-unused-expressions
    data != null
      ? setState(newState => ({
          ...newState,
          openWarningSidePanel: isOpen,
          clinicianGroupWithDefaultValues: data,
        }))
      : setState(newState => ({
          ...newState,
          openWarningSidePanel: isOpen,
          clinicianGroupWithDefaultValues,
        }));
  };

  return {
    locale,
    addButtonText: locale.getMsg('addButtonText'),
    refreshTable,
    handleSidePanel,
    updateTableProps,
    updateTableSort,
    onClose,
    handleWarningPanel,
    createOrEditClinicianGroup: model => {
      postCreateOrEditClinicianGroup(auth, model, refreshTable, errorCallback);
    },
    onConfirmWarning: () => {
      disableClinicianGroup(
        auth,
        { clinicianGroupId: state.clinicianGroupWithDefaultValues.id },
        refreshTable,
        errorCallback,
      );
    },
  };
};
